import styled from 'styled-components';

const SubContainer = styled.div`
  min-height: 70vh;
  margin-left: 40px;
`;

export default SubContainer;
